<div class="company-funnel-container">
  <div class="stepper">
    <cowing-core-coworking-stepper [steps]="steps"></cowing-core-coworking-stepper>
  </div>
  <div class="form">
    <company-plus-core-company-info
            *ngIf="whatStepIsActive === 1"
            [form]="registerForm.get('generalForm')"
            (location)="setLocation($event)"
    ></company-plus-core-company-info>

    <cowing-core-company-employees
            *ngIf="whatStepIsActive === 2"
            [form]="registerForm.get('employeesForm')"
    ></cowing-core-company-employees>

    <cowing-core-company-spaces
            *ngIf="whatStepIsActive === 3"
            [form]="registerForm.get('spacesForm')"
    >
    </cowing-core-company-spaces>

    <cowing-core-company-services
            *ngIf="whatStepIsActive === 4"
            [form]="registerForm.get('servicesForm')"
    >
    </cowing-core-company-services>

    <cowing-core-company-paymethods
            *ngIf="whatStepIsActive === 5"
            [form]="registerForm.get('paymethodsForm')"
            [secondForm]="registerForm.get('cardForm')"
            (location)="setLocationPaymethod($event)"
    ></cowing-core-company-paymethods>

    <cowing-core-coworking-confirm
            [isCompany]="true"
            *ngIf="whatStepIsActive === 6"
    ></cowing-core-coworking-confirm>
  </div>

  <div class="actions">
    <cowing-button *ngIf="whatStepIsActive !== 2" [label]="
        isInitStep
          ? ('coworking.cancel' | translate)
          : ('coworking.back' | translate)
      " [type]="EButtonType.RoundedSecondary" [iconShow]="false"
      (event)="isInitStep ? goBack() : setPreviousStep($event)"></cowing-button>
    <div *ngIf="whatStepIsActive === 2" class="step-2">
      <cowing-button [label]="
          isInitStep
            ? ('coworking.cancel' | translate)
            : ('coworking.back' | translate)
        " [type]="EButtonType.RoundedSecondary" [iconShow]="false"
        (event)="isInitStep ? goBack() : setPreviousStep($event)"></cowing-button>
      <cowing-button [disabled]="skipDisabled" [label]="'company.employees.skip' | translate"
        [type]="EButtonType.RoundedSecondary" [iconShow]="false" (event)="skipEmployeesCompany()">
      </cowing-button>
    </div>
    <div class="inline">
      <cowing-button *ngIf="whatStepIsActive === 5" [label]="'company.employees.skip' | translate"
        [type]="EButtonType.RoundedSecondary" [iconShow]="false" (event)="skipBankInfoCompany()">
      </cowing-button>
      <cowing-button [disabled]="isDisabledNextStep" [label]="isLastStep ? 'Entendido' : 'Continuar'"
        [type]="EButtonType.Rounded" [iconShow]="false" (event)="setNextStep($event)">
      </cowing-button>
    </div>
  </div>
</div>
